module.exports = __webpack_public_path__ + "static/media/epsRENBTC.7b53d9cc.png";